module.exports = __webpack_public_path__ + "static/flags/SO-6d4a9c187b438fab175bebd1b736f925.gif";